import clsx from 'clsx';

import AemImage from '@/components/AemImage/AemImage';
import type {ImageModel} from '@/types/content';

type BigCardContentProps = {
    title?: string;
    imageMedia?: ImageModel[];
    isBigBorderless: boolean;
};

const BigCardContent = ({title, imageMedia, isBigBorderless}: BigCardContentProps) => (
    <div className='relative w-full overflow-hidden rounded-2xl'>
        {imageMedia && imageMedia.length > 0 && (
            <AemImage
                imageMedia={imageMedia}
                className='w-full'
                pictureClassName='w-full'
                imgClassName={clsx('w-full h-auto object-cover', isBigBorderless && 'object-right')}
            />
        )}

        <h2 className='pointer-events-none absolute inset-x-0 top-0 m-0 px-4 pt-4 font-bold text-lg text-white'>
            {title}
        </h2>
    </div>
);

export default BigCardContent;
